//Lägg till nytt fält som säger vilken nivå vi är på. Hänvisa till det i prompten
export const SammanfattningRowsFormat = `[ 
  "currentLevel": "Benämningen på den nuvarande nivån ",  
  "header": "Namn på verksamhetsområde/verksamhetsnivå/verksamhet/baskonto",
  "utgaendeVarde" : "Utgående värde för för innevarande år till och med angiven period", 
  "utgaendeVardeLastYear" : "Utgående värde för föregående år",
  "utgaendeVardePeriodLastYear" : "Utgående värde för föregående år till och med angiven period",
  "budgetArVarde" : "Budgeterat värde för innevarande år",
  "budgetRiktvarde" : "Budgetens riktvärde för perioden",
  "avvikelseBudgetRiktvarde" : "Avvikelse mot budgetens riktvärde",
  "avvikelseProcentBudgetRiktvarde" : "Avvikelse mot budgetens riktvärde i procent",
  "helarsPrognos" : "Helårsprognos baserat på utgående värde för perioden"
] `;

export const aiInsikterSvarsFormat = `{ 
  "insikter": [
    {
      "rubrik": "Nyckelinsikt 1",
      "beskrivning": "Beskrivning av nyckelinsikt 1"
    },
    {
      "rubrik": "Nyckelinsikt 2",
      "beskrivning": "Beskrivning av nyckelinsikt 2"
    },
     {
      "rubrik": "Nyckelinsikt 3",
      "beskrivning": "Beskrivning av nyckelinsikt 2"
    }
  ],
  "rekommendationer": [
    {
      "rubrik": "Rekommendation 1",
      "beskrivning": "Beskrivning av rekommendation 1"
    },
    {
      "rubrik": "Rekommendation 2",
      "beskrivning": "Beskrivning av rekommendation 2"
    },
    {
      "rubrik": "Rekommendation 3",
      "beskrivning": "Beskrivning av rekommendation 3"
    }
  ],
  "kommentar": "Om du har en kommentar kan du lägga in det här"
}`;
